import {
  Badge,
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  message,
  Radio,
  Row,
  Select,
  Switch,
} from "antd";
import apiClient from "services/apiClient";

import React, { useCallback, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useMyContext } from "Context/MyContextProvider";
import { useTemplates } from "hooks/api";
import Flex from "components/shared-components/Flex";
import "react-transliterate/dist/index.css";
import Groups from "../Campaign/Groups";
import CarouselPreview from "./carouselPreview";
import {
  filterNumbers,
  formatNumber,
  validateUserAndBalance,
} from "../Campaign/CampainComps/OtherUtils";
import ModeLindex from "../Campaign/CampainComps/ModeLindex";
import CommonNumberField from "../Campaign/CampainComps/CommonNumberField";
import CardData from "./CarouselCampaignComps.js/CardData";
import MotionError from "../Campaign/CampainComps/MotionError";
import {
  buildCarouselCardsForCampaign,
  HandleCarouselTemplate,
  HandleDynamicValues,
  handleUrlButtonChange,
} from "./CarouselCampaignComps.js/carouselUtils";
import {
  buildValidateCampaignPayload,
  getValidateCampaignResult,
  getApiErrorMessage,
  handleCampaignValidationFailure,
  handleRemoveInactiveGatewayNumbers,
} from "../CustomUtils.js/CampaignUtils";
import { useCampaignProgress } from "../Hooks/useCampaignProgress";
import useInternationalGateway from "../Hooks/useInternationalGateway";

const CarouselCampaign = ({ isReTarget = false }) => {
  const location = useLocation();
  const {
    id: reTargetCampaignId,
    campaign_name: reTargetCampaignName,
    send_config,
    recipient_mode,
    report_summary: retargetReportSummary,
  } = location.state || {};
  const {
    UserData,
    api,
    authToken,
    Permisson,
    navigate,
    buttonStyle,
    calculateRequredBalance,
  } = useMyContext();

  const { templates = [] } = useTemplates();


  const [templateList, setTemplateList] = useState([]);
  const [componentSize, setComponentSize] = useState("small");
  const [number, setNumber] = useState("");
  const [dynamicValues, setDynamicValues] = useState([]);
  const [templateName, setTemplateName] = useState("");
  const [newMesaage, setNewMessage] = useState("");
  const [name, setName] = useState("");
  const [templatePreview, setTemplatePreview] = useState([]);
  const [thumbnail, setThumbnail] = useState("");
  const [urlButtons, setUrlButtons] = useState([]);
  const [numbers, SetNumbers] = useState([]);

  const [open, setOpen] = useState(false);
  const [templateCategory, setTemplateCategory] = useState();
  const [templateType] = useState("carousel");
  const [blockNumbers, setBlockNumbers] = useState([]);
  const [templateLanguage, setTemplateLanguage] = useState("");
  const [openMediaModel, setOpenMediaModel] = useState(false);
  const [openScheduleModel, setOpenSchedule] = useState(false);
  const [scheduleDate, setScheduleDate] = useState("");
  const [scheduleTime, setScheduleTime] = useState("");
  const [loading, setLoading] = useState(false);
  const [isInternational, setIsInternational] = useState(recipient_mode === 'international');
  const { gatewayEnabled } = useInternationalGateway({
    api,
    authToken,
    userId: UserData?.id,
  });

  useEffect(() => {
    if (!gatewayEnabled && isInternational) {
      setIsInternational(false);
    }
  }, [gatewayEnabled, isInternational]);

  const {
    progress,
    setProgress,
    setIsSending,
    isModalVisible,
    setIsModalVisible,
    error,
    setError,
    startCampaignChannel,
    resetCampaign: resetCampaignProgress,
  } = useCampaignProgress();

  const [initialTemplates, setInitialTemplates] = useState([]);
  const [mainBody, setMainBody] = useState(null);
  const [mainBodyInputs, setMainBodyInputs] = useState([]);

  const [cardData, setCardData] = useState([]);
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [cards, setCards] = useState();
  const [existingMediaIDs, setExistingMediaIDs] = useState([]);
  const [cardButtonValues, setCardButtonValues] = useState({});
  const [inactiveGatewayModal, setInactiveGatewayModal] = useState(false);
  const [inactiveGatewayGroups, setInactiveGatewayGroups] = useState([]);
  const [inactiveGatewayMessage, setInactiveGatewayMessage] = useState("");
  const [internationalInfoOpen, setInternationalInfoOpen] = useState(false);

  const handleInternationalModeChange = (checked) => {
    setIsInternational(checked);
    if (checked) {
      setInternationalInfoOpen(true);
    }
  };

  // Retarget-specific state
  const [selectedStatuses, setSelectedStatuses] = useState([]);
  const [reTargetReady, setReTargetReady] = useState(false);
  const statusCounts = {
    pending: Number(retargetReportSummary?.pending || 0),
    sent: Number(retargetReportSummary?.sent || 0),
    delivered: Number(retargetReportSummary?.delivered || 0),
    read: Number(retargetReportSummary?.read || 0),
    failed: Number(retargetReportSummary?.failed || 0),
  };

  const [form] = Form.useForm();

  useEffect(() => {
    const GetBlockNumber = async () => {
      try {
        const response = await apiClient.get(
          `${api}get-block-numbers/${UserData?.id}`,
          {
            headers: {
              Authorization: "Bearer " + authToken,
            },
          }
        );
        const serverBlocked = response.data.serverBlocked;
        const userBlocked = response.data.serverBlocked;
        const serverNumbers = serverBlocked
          .map((item) => formatNumber(item.numbers))
          .filter(Boolean);
        const userNumbers = userBlocked
          .map((item) => formatNumber(item.numbers))
          .filter(Boolean);
        const total = [...serverNumbers, ...userNumbers];
        setBlockNumbers([...new Set(total)]);
      } catch (error) {
        console.log(error);
      }
    };

    if (UserData?.id) {
      GetBlockNumber();
    }
  }, [api, UserData?.id, authToken]);

  useEffect(() => {
    if (templates.length > 0) {
      const carouselTemplates = templates?.filter((template) =>
        template.components?.some((comp) => comp.type === "CAROUSEL")
      );
      setInitialTemplates(carouselTemplates);
      setTemplateList(carouselTemplates);
    }
  }, [templates]);

  // Consolidated autofill: runs once when templates are loaded in retarget mode
  useEffect(() => {
    if (!isReTarget || !send_config || templates.length === 0 || reTargetReady) return;

    // 0. Prefill campaign name
    if (reTargetCampaignName) {
      const defaultName = reTargetCampaignName + ' - Retarget';
      setName(defaultName);
      form.setFieldsValue({ 'Campaign-Name': defaultName });
    }

    // 1. Set template category + sync Ant Design form
    setTemplateCategory(send_config.template_category);
    form.setFieldsValue({
      Template_category: send_config.template_category,
      Templates: send_config.template_name,
    });

    // 2. Load template structure (sets cards, mainBody, inputs etc.)
    HandleCarouselTemplate(
      send_config.template_name,
      () => {},
      setExistingMediaIDs,
      setTemplateName,
      templates,
      () => {},
      setTemplateLanguage,
      setTemplatePreview,
      setMainBody,
      setCards,
      urlButtons,
      setMainBodyInputs,
      setCardData,
      setDynamicValues,
      send_config.body_values
    );

    // 3. Prefill card media IDs and button values
    if (send_config.carousel_cards?.length > 0) {
      const mediaIDs = send_config.carousel_cards.map(c => c.media_id || '');
      setExistingMediaIDs(mediaIDs);

      // Also set mediaLink on each card in cardData after a tick
      setTimeout(() => {
        setCardData(prev => prev.map((card, idx) => {
          const configCard = send_config.carousel_cards[idx];
          if (configCard?.media_id) {
            return { ...card, mediaLink: configCard.media_id };
          }
          return card;
        }));
      }, 0);

      const buttonVals = {};
      send_config.carousel_cards.forEach((card, cardIdx) => {
        if (Array.isArray(card.button_values)) {
          card.button_values.forEach((val, btnIdx) => {
            if (val) buttonVals[`${cardIdx}_${btnIdx}`] = val;
          });
        } else if (card.button_values && typeof card.button_values === 'object') {
          Object.entries(card.button_values).forEach(([btnIdx, val]) => {
            if (val) buttonVals[`${cardIdx}_${btnIdx}`] = val;
          });
        }
      });
      setCardButtonValues(buttonVals);
    }

    // 4. Body dynamic values
    if (send_config.body_values?.length > 0) {
      setDynamicValues(send_config.body_values);
    }

    setReTargetReady(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isReTarget, send_config, templates, reTargetReady]);

  const retargetStatuses = [
    { label: 'Pending', value: 'pending' },
    { label: 'Sent', value: 'sent' },
    { label: 'Delivered', value: 'delivered' },
    { label: 'Read', value: 'read' },
    { label: 'Failed', value: 'failed' },
  ];

  const selectedStatusCount = selectedStatuses.reduce(
    (sum, status) => sum + (statusCounts[status] || 0),
    0
  );
  const hasRetargetRecipients = isReTarget && selectedStatuses.length > 0 && selectedStatusCount > 0;

  const handleStatusCheckboxChange = (checkedValues) => {
    setSelectedStatuses(checkedValues);
  };

  const withRetargetFields = (payload) => (
    hasRetargetRecipients
      ? {
          ...payload,
          source_campaign_id: reTargetCampaignId,
          statuses: selectedStatuses,
        }
      : payload
  );

  useEffect(() => {
    if (templateCategory) {
      const filteredList = initialTemplates?.filter(
        (item) => item.category === templateCategory
      );
      setTemplateList(filteredList);
    } else {
      setTemplateList(initialTemplates);
    }
  }, [templateCategory, initialTemplates]);

  const onFormLayoutChange = ({ size }) => {
    setComponentSize(size);
  };

  const HandleTemplate = (value) => {
    HandleCarouselTemplate(
      value,
      () => {},
      setExistingMediaIDs,
      setTemplateName,
      templates,
      () => {},
      setTemplateLanguage,
      setTemplatePreview,
      setMainBody,
      setCards,
      urlButtons,
      setMainBodyInputs,
      setCardData,
      setDynamicValues
    );
  };

  useEffect(() => {
    HandleDynamicValues(templatePreview, dynamicValues, setNewMessage);
  }, [templatePreview, dynamicValues]);

  const GetGroupNumber = useCallback((value) => {
    const uniqueNumbersSet = [...new Set(value)];
    SetNumbers(uniqueNumbersSet);
  }, []);

  const showModal = async () => {
    setOpen(true);
  };
  const handleCancel = () => {
    setOpen(false);
  };

  // for media model

  const showMediaModel = (index) => {
    setCurrentCardIndex(index); // Set the current card index
    setOpenMediaModel(true);
  };
  const handleCancelMediaModel = () => {
    setOpenMediaModel(false);
  };

  const getFilteredCarouselNumbers = () => {
    const numberArray = number
      ? number
          ?.split("\n")
          ?.map((num) => num?.trim())
          ?.filter((num) => num)
      : [];
    const mergedNumbers = [...numberArray, ...numbers];
    return filterNumbers(mergedNumbers, blockNumbers, isInternational);
  };

  const validateCarouselBeforeSend = () => {
    const missingCardIndexes = getMissingCardIndices(cardData);
    if (missingCardIndexes.length > 0) {
      const cardNumbers = missingCardIndexes.join(", ");
      message.error(
        `Cards ${cardNumbers} are missing media files. Please select and upload files for these cards.`
      );
      return null;
    }

    if (templateName === "") {
      setError("You have to select a template first");
      return null;
    }

    const filteredNumbers = getFilteredCarouselNumbers();

    if (!name || filteredNumbers.length === 0 || !templateName) {
      setError("Invalid input data");
      return null;
    }

    if (filteredNumbers.length > 100000) {
      setError("You can only process up to 100000 numbers.");
      return null;
    }

    return filteredNumbers;
  };

  const showScheduleModel = async () => {
    const filteredNumbers = validateCarouselBeforeSend();
    if (!filteredNumbers) {
      return;
    }

    const isEnoughBalance = await validateUserAndBalance(
      filteredNumbers.length,
      calculateRequredBalance,
      templateCategory,
      showModal
    );

    if (!isEnoughBalance) {
      showModal();
      return;
    }

    setOpenSchedule(true);
  };

  const handleCancelScheduleModel = () => {
    setOpenSchedule(false);
  };

  const HandleScheduleTime = (value) => {
    if (!value?.$d) {
      setScheduleDate("");
      setScheduleTime("");
      return;
    }

    const { $d } = value;
    const year = $d.getFullYear();
    const month = $d.getMonth() + 1;
    const day = $d.getDate();
    const hours = $d.getHours();
    const minutes = $d.getMinutes();
    setScheduleDate(`${year}-${month}-${day}`);
    setScheduleTime(`${hours}:${minutes}:00`);
  };

  const HandleSchedule = async () => {
    if (!scheduleDate || !scheduleTime) {
      setError("Please select a schedule date and time.");
      return;
    }

    const filteredNumbers = validateCarouselBeforeSend();
    if (!filteredNumbers) {
      return;
    }

    await submitCarouselCampaign(filteredNumbers, { schedule: true });
  };

  const HandleUploadImage = (path, name) => {
    if (path) {
      setExistingMediaIDs((prevMediaIDs) => {
        const updatedMediaIDs = [...prevMediaIDs];
        updatedMediaIDs[currentCardIndex] = path; // Replace the media ID at the current index
        return updatedMediaIDs;
      });
      setCardData((prevData) =>
        prevData.map((card, index) =>
          index === currentCardIndex
            ? { ...card, mediaLink: path, mediaName: name }
            : card
        )
      );
      setOpenMediaModel(false);
    }
  };

  const groupsRef = useRef(null);
  const [groupsKey, setGroupsKey] = useState(0);

  const resetCampaign = () => {
    resetCampaignProgress();
    setNumber("");
    setGroupsKey((prevKey) => prevKey + 1);
  };

  const handleMediaLinkChange = (value, index) => {
    const newMediaLink = value;
    setCardData((prevData) =>
      prevData.map((card, i) =>
        i === index ? { ...card, mediaLink: newMediaLink } : card
      )
    );
  };

  const [showAlert, setShowAlert] = useState(false);
  const [isLoop, setIsLoop] = useState(true);

  useEffect(() => {
    if (showAlert) {
      message.error("Please provide the required media link and media type.");
    }
  }, [showAlert]);

  const handleSwitchChange = (checked) => {
    setIsLoop(checked);
  };

  // Utility function to check for missing media files
  const getMissingCardIndices = (cardData) => {
    return cardData
      .map((card, index) =>
        card.mediaType === "Media" && !card.mediaLink ? index + 1 : null
      )
      .filter((index) => index !== null);
  };

  // Utility function to check user status
  const normalizeBodyValues = (values) =>
    Array.isArray(values)
      ? values
        .filter((value) => typeof value === "string" || typeof value === "number")
        .map((value) => String(value))
      : [];

  const submitCarouselCampaign = async (filteredNumbers, { schedule = false } = {}) => {
    if (!name || !String(name).trim()) {
      setError("Please enter campaign name!");
      return;
    }

    if ((!Array.isArray(filteredNumbers) || filteredNumbers.length === 0) && !hasRetargetRecipients) {
      setError("No valid numbers to process");
      return;
    }

    if (schedule && (!scheduleDate || !scheduleTime)) {
      setError("Please select a schedule date and time.");
      return;
    }

    try {
      setLoading(true);
      setError("");

      const validationResponse = await apiClient.post(
        `${api}validate-campaign`,
        buildValidateCampaignPayload({
          userId: UserData.id,
          campaignType: "template",
          templateName,
          filteredNumbers,
          templateCategory,
          isInternational: gatewayEnabled ? isInternational : false,
          sourceCampaignId: hasRetargetRecipients ? reTargetCampaignId : undefined,
          statuses: hasRetargetRecipients ? selectedStatuses : undefined,
        }),
        {
          headers: {
            Authorization: "Bearer " + authToken,
          },
        }
      );

      const validation = getValidateCampaignResult(validationResponse);

      if (validation.canProceed === false) {
        handleCampaignValidationFailure(validation, {
          setError,
          showBalanceModal: showModal,
          setInactiveGatewayModal,
          setInactiveGatewayGroups,
          setInactiveGatewayMessage,
        });
        if (!schedule) {
          setIsModalVisible(false);
        }
        return;
      }

      if (!schedule) {
        setIsModalVisible(true);
      }

      const campaignPayload = withRetargetFields({
        name,
        user_id: UserData.id,
        numbers: filteredNumbers.map((n) => String(n)),
        campaign_type: "template",
        template_name: templateName,
        template_language: templateLanguage,
        template_category: templateCategory,
        body_values: normalizeBodyValues(dynamicValues),
        carousel_cards: buildCarouselCardsForCampaign(cardData, cardButtonValues),
        campaign_source: "manual",
        international: gatewayEnabled ? isInternational : false,
      });

      if (schedule) {
        campaignPayload.schedule_date = scheduleDate;
        campaignPayload.schedule_time = scheduleTime;
      }

      const response = await apiClient.post(`${api}send-campaign`, campaignPayload, {
        headers: {
          Authorization: "Bearer " + authToken,
        },
      });

      if (schedule) {
        const scheduleTimeLabel =
          response?.data?.data?.schedule_time ||
          `${scheduleDate} ${scheduleTime}`;
        message.success(`Campaign scheduled for ${scheduleTimeLabel}`);
        setOpenSchedule(false);
        navigate("/schedule-campaign");
        return;
      }

      const newCampaignId =
        response?.data?.campaign_id ||
        response?.data?.data?.campaign_id ||
        response?.data?.campaign?.id;

      if (!newCampaignId) {
        setIsModalVisible(false);
        setError("Campaign queued but campaign_id was not returned");
        return;
      }

      setProgress(0);
      setIsSending(true);

      if (filteredNumbers.length > 5) {
        startCampaignChannel(UserData?.id, newCampaignId);
      } else {
        setProgress(100);
        setIsSending(false);
      }
    } catch (err) {
      if (!schedule) {
        setIsModalVisible(false);
      }
      const validation = getValidateCampaignResult(err?.response);
      if (
        !handleCampaignValidationFailure(validation, {
          setError,
          showBalanceModal: showModal,
          setInactiveGatewayModal,
          setInactiveGatewayGroups,
          setInactiveGatewayMessage,
        })
      ) {
        setError(getApiErrorMessage(err));
      }
    } finally {
      setLoading(false);
    }
  };

  // Main handler function
  const HandleSubmit = async () => {
    try {
      const filteredNumbers = validateCarouselBeforeSend();
      if (!filteredNumbers) {
        return;
      }

      validateUserAndBalance(
        filteredNumbers?.length,
        calculateRequredBalance,
        templateCategory,
        showModal
      );

      await submitCarouselCampaign(filteredNumbers);
    } catch (submitError) {
      setError(submitError.message);
    }
  };

  const handleTabChange = (key) => {
    const newIndex = parseInt(key, 10);
    setCurrentCardIndex(newIndex);
  };

  // Reset all template-related fields - called directly from Radio onChange
  const resetTemplateFields = () => {
    setTemplateName("");
    setMainBody(null);
    setMainBodyInputs([]);
    setDynamicValues([]);
    setCardData([]);
    setCards(null);
    setExistingMediaIDs([]);
    setCardButtonValues({});
    setTemplatePreview([]);
    setThumbnail("");
    setUrlButtons([]);
    setNewMessage("");
    setCurrentCardIndex(0);
  };

  const handleCategoryChange = (value) => {
    resetTemplateFields();
    setTemplateCategory(value);
  };

  const handleCloseInactiveGatewayModal = () => {
    setInactiveGatewayModal(false);
  };

  const handleRemoveInactiveNumbers = () => {
    handleRemoveInactiveGatewayNumbers({
      inactiveGatewayGroups,
      numbers,
      number,
      SetNumbers,
      setNumber,
      international: isInternational,
      onClose: () => {
        setInactiveGatewayModal(false);
        setInactiveGatewayGroups([]);
        setInactiveGatewayMessage("");
        setError("");
      },
    });
  };

  return (
    <>
      <ModeLindex
        open={open}
        handleCancel={handleCancel}
        UserData={UserData}
        openScheduleModel={openScheduleModel}
        handleCancelScheduleModel={handleCancelScheduleModel}
        HandleScheduleTime={HandleScheduleTime}
        HandleSchedule={HandleSchedule}
        scheduleDate={scheduleDate}
        scheduleTime={scheduleTime}
        openMediaModel={openMediaModel}
        handleCancelMediaModel={handleCancelMediaModel}
        HandleUploadImage={HandleUploadImage}
        requestType={"template"}
        progress={progress}
        isModalVisible={isModalVisible}
        loading={loading}
        resetCampaign={resetCampaign}
        navigate={navigate}
        inactiveGatewayModal={inactiveGatewayModal}
        inactiveGatewayMessage={inactiveGatewayMessage}
        inactiveGatewayGroups={inactiveGatewayGroups}
        handleRemoveInactiveNumbers={handleRemoveInactiveNumbers}
        handleCloseInactiveGatewayModal={handleCloseInactiveGatewayModal}
        internationalInfoOpen={internationalInfoOpen}
        handleCloseInternationalInfo={() => setInternationalInfoOpen(false)}
      />
      <Row gutter={12}>
        {Permisson?.includes("View Campaign") && (
          <>
            <Col xs={24} sm={24} md={24} lg={12}>
              <Card
                title={isReTarget ? "Carousel Re-Target Campaign" : "Carousel Campaign"}
                extra={
                  gatewayEnabled ? (
                    <span className="d-flex align-items-center" style={{ gap: 8 }}>
                      <span className="text-muted">Domestic</span>
                      <Switch
                        disabled={isReTarget}
                        checked={isInternational}
                        onChange={handleInternationalModeChange}
                        checkedChildren="INT"
                        unCheckedChildren="IN"
                      />
                      <span className="text-muted">International</span>
                    </span>
                  ) : null
                }
              >
                {/* Error Alert */}
                <MotionError error={error} />
                {/* Form */}
                <Form
                  form={form}
                  name="basicInformation"
                  layout="vertical"
                  initialValues={{ size: componentSize }}
                  onValuesChange={onFormLayoutChange}
                  size={componentSize}
                >
                  <Row>
                    {/* Campaign Name */}
                    <Col span={24}>
                      <Form.Item
                        label="Campaign Name"
                        name="Campaign-Name"
                        className="m-0"
                        rules={[
                          {
                            required: true,
                            message: "Please enter campaign name!",
                          },
                        ]}
                      >
                        <Input
                          type="text"
                          value={name}
                          onChange={(e) => setName(e.target.value)}
                        />
                        <span className="d-none">{name}</span>
                      </Form.Item>
                    </Col>

                    {/* Retarget: Status Category Checkboxes */}
                    {isReTarget && (
                      <Col span={24}>
                        <Form.Item label="Select Recipients by Status">
                          <Checkbox.Group
                            className="d-flex flex-wrap gap-2"
                            onChange={handleStatusCheckboxChange}
                          >
                            {retargetStatuses.map((s) => (
                              <Checkbox key={s.value} value={s.value}>
                                {s.label}{" "}
                                <Badge
                                  count={statusCounts[s.value] || 0}
                                  overflowCount={999999}
                                  style={{
                                    backgroundColor: s.value === 'failed' ? '#ff4d4f' : '#52c41a',
                                    marginLeft: 4,
                                  }}
                                />
                              </Checkbox>
                            ))}
                          </Checkbox.Group>
                        </Form.Item>
                      </Col>
                    )}

                    {/* Standard number field — hide in retarget mode (numbers come from checkboxes) */}
                    {!isReTarget && (
                      <Col span={24}>
                        <CommonNumberField
                          numbers={numbers}
                          number={number}
                          setNumber={setNumber}
                          groupsKey={groupsKey}
                        />
                      </Col>
                    )}

                    {/* Template Type */}
                    {/* <Col span={24}>
                      <Form.Item label="Template Type">
                        <Radio.Group
                          value={templateType}
                          onChange={(e) => {
                            const val = e.target.value;
                            if (val === "normal") {
                              navigate("/new-campaign");
                            } else {
                              setTemplateType(val);
                            }
                          }}
                        >
                          <Radio value="normal">Normal</Radio>
                          <Radio value="carousel">Carousel</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col> */}

                    {templateType === "carousel" && (
                      <>
                        {/* Template Category */}
                        <Col span={12}>
                          <Form.Item
                            label="Template Category"
                            name="Template_category"
                          >
                            <Radio.Group
                              onChange={(e) => handleCategoryChange(e.target.value)}
                              value={templateCategory}
                            >
                              <Radio value="MARKETING">Marketing</Radio>
                              <Radio value="UTILITY">Utility</Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>

                        {/* Templates Selection */}
                        {templateCategory && (
                          <Col span={12}>
                            <Form.Item label="Templates" name="Templates">
                              <Select
                                size="default"
                                style={{ width: "100%" }}
                                value={templateName || undefined}
                                onChange={(value) => HandleTemplate(value)}
                                showSearch
                              >
                                <Select.Option value="choose...">
                                  Select
                                </Select.Option>
                                {templateList?.length > 0 ? (
                                  templateList.map((item, index) => (
                                    <Select.Option value={item.name} key={index}>
                                      {item.name}
                                    </Select.Option>
                                  ))
                                ) : (
                                  <Select.Option value="">
                                    You Don't Have Any Approved Templates
                                  </Select.Option>
                                )}
                              </Select>
                            </Form.Item>
                          </Col>
                        )}

                        {/* Dynamic Values */}
                        {mainBodyInputs?.length > 0 && (
                          <Col span={24}>
                            <Form.Item
                              label={`${mainBodyInputs.length} dynamic values detected`}
                            >
                              {mainBodyInputs.map((input, index) => (
                                <div key={index} className="mb-2">
                                  {input}
                                </div>
                              ))}
                            </Form.Item>
                          </Col>
                        )}
                        {/* Carousel Cards */}
                        <CardData
                          cardData={cardData}
                          handleUrlButtonChange={handleUrlButtonChange}
                          setCardButtonValues={setCardButtonValues}
                          cardButtonValues={cardButtonValues}
                          handleTabChange={handleTabChange}
                          buttonStyle={buttonStyle}
                          showMediaModel={showMediaModel}
                          handleMediaLinkChange={handleMediaLinkChange}
                        />

                        {/* Submit Buttons */}
                        <Col span={24}>
                          <Flex alignItems="center" gap={16}>
                            {Permisson?.includes("Create Campaign") && (
                              <>
                                <Button
                                  type="primary"
                                  htmlType="submit"
                                  onClick={(e) => HandleSubmit(e)}
                                  loading={loading}
                                >
                                  Submit
                                </Button>
                                <Button
                                  onClick={() => showScheduleModel()}
                                  loading={loading}
                                >
                                  Schedule Campaign
                                </Button>
                              </>
                            )}
                          </Flex>
                        </Col>
                      </>
                    )}
                  </Row>
                </Form>
              </Card>
            </Col>
            {/* mobile preview  */}
            <Col xs={24} sm={24} md={24} lg={6}>
              <Card
                title={
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>Campaign Preview</span>
                    <Flex alignItems="center">
                      <span className="h5 m-0 mr-2 p-0">Auto Scroll</span>
                      <Switch checked={isLoop} onChange={handleSwitchChange} />
                    </Flex>
                  </div>
                }
              >
                <CarouselPreview
                  mainBody={mainBody}
                  mediaLink={existingMediaIDs}
                  requestType={"template"}
                  cards={cards}
                  isLoop={isLoop}
                  thumbnail={thumbnail}
                  dynamicValues={dynamicValues}
                  newMesaage={newMesaage}
                  urlButtons={urlButtons}
                  currentCardIndex={currentCardIndex}
                  customMessage={null}
                />
              </Card>
            </Col>
          </>
        )}
        {Permisson?.includes("View Group") && (
          <Col xs={24} sm={24} md={24} lg={6}>
            <Groups
              key={groupsKey}
              ref={groupsRef}
              GetGroupNumber={GetGroupNumber}
            />
          </Col>
        )}
      </Row>
    </>
  );
};

export default CarouselCampaign;
